import { api } from "@/redux/api";

import {
	KpiDashboardResponseSchema,
	KpiDashboardResponse,
	KpiHasDataResponse,
	KpiHasDataResponseSchema,
	KpiCoursesResponse,
	KpiCoursesResponseSchema,
} from "../../pages/KpiDashboard/schema/kpi";

export const kpiApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getKpiDashboard: builder.query<
			KpiDashboardResponse,
			{
				startDate?: string;
				endDate?: string;
				groupBy?: "day" | "week";
				courseIds?: number[];
			}
		>({
			query: ({ courseIds, startDate, endDate, groupBy }) => {
				const parts: string[] = [];

				if (startDate) {
					parts.push(`startDate=${startDate}`);
				}

				if (endDate) {
					parts.push(`endDate=${endDate}`);
				}

				if (groupBy) {
					parts.push(`groupBy=${groupBy}`);
				}

				courseIds?.forEach((id) => parts.push(`courseIds=${id}`));

				return {
					url: `kpi/dashboard?${parts.join("&")}`,
					responseSchema: KpiDashboardResponseSchema,
				};
			},
			providesTags: ["Kpi"],
		}),
		getKpiCourses: builder.query<KpiCoursesResponse, void>({
			query: () => ({
				url: "kpi/courses",
				responseSchema: KpiCoursesResponseSchema,
			}),

			providesTags: ["Kpi"],
		}),
		getKpiHasData: builder.query<KpiHasDataResponse, void>({
			query: () => ({
				url: "kpi/has-data",
				responseSchema: KpiHasDataResponseSchema,
			}),
			providesTags: ["Kpi"],
		}),
		deleteKpiData: builder.mutation<{ deleted: number }, number | void>({
			query: (companyId) => ({
				url: companyId ? `kpi?companyId=${companyId}` : "kpi",
				method: "DELETE",
			}),
			invalidatesTags: ["Kpi"],
		}),
	}),
});

export const {
	useGetKpiDashboardQuery,
	useGetKpiCoursesQuery,
	useGetKpiHasDataQuery,
	useDeleteKpiDataMutation,
} = kpiApi;
